{
  "tabs": {
    "chat": "チャット",
    "reminders": "リマインダー",
    "calendar": "カレンダー",
    "settings": "設定"
  },
  "common": {
    "cancel": "キャンセル",
    "save": "保存",
    "confirm": "確認",
    "delete": "削除",
    "back": "戻る",
    "close": "閉じる",
    "edit": "編集",
    "search": "検索",
    "all": "すべて",
    "loading": "読み込み中...",
    "error": "問題が発生しました",
    "notFound": "見つかりません",
    "tryAgain": "もう一度お試しください",
    "retry": "再試行",
    "undo": "元に戻す",
    "pullToRefresh": "引いて更新",
    "justNow": "たった今"
  },
  "auth": {
    "welcome": "FishMemoryへようこそ",
    "tagline": "あなたのWhatsAppリマインダーアシスタント、今ポケットに。",
    "subtitle": "あなたのWhatsAppリマインダーアシスタント、今ポケットに。",
    "phoneLabel": "あなたのWhatsApp番号",
    "phoneHint": "WhatsAppで認証コードを送信します",
    "invalidPhone": "有効な電話番号を入力してください",
    "continue": "続行",
    "enterPhone": "WhatsApp番号を入力してください",
    "phonePlaceholder": "電話番号",
    "sendCode": "コード送信",
    "verifyTitle": "番号を確認",
    "otpSentTo": "6桁のコードを{{phone}}にWhatsAppで送信しました",
    "enterFullCode": "6桁すべてを入力してください",
    "invalidOtp": "無効なコードです。再試行してください。",
    "otpFailed": "コード送信に失敗しました。再試行してください。",
    "otpResent": "コードを再送信しました",
    "resendIn": "{{seconds}}秒後に再送信",
    "resendCode": "コード再送信",
    "enterOtp": "WhatsAppに送信されたコードを入力してください",
    "verify": "確認",
    "resend": "コード再送信",
    "wrongNumber": "番号が違いますか？",
    "backToPhone": "電話番号に戻る",
    "editPhone": "電話番号を編集",
    "error": "エラー",
    "setupTitle": "設定を始めましょう",
    "setupSubtitle": "後で設定からいつでも変更可能です",
    "namePlaceholder": "あなたの名前",
    "letsGo": "設定完了",
    "skipForNow": "とりあえずスキップ"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "メッセージを入力...",
    "inputPlaceholder": "メッセージを入力...",
    "typing": "FishMemoryが入力中...",
    "online": "オンライン",
    "connecting": "接続中...",
    "reconnecting": "再接続中...",
    "offline": "オフライン",
    "empty": "会話を始めましょう",
    "emptyHint": "リマインダー作成、予定確認、ヘルプをどうぞ。",
    "emptyAction": "サンプルリマインダー送信",
    "actions": "チャット操作",
    "keep": "メッセージを保持",
    "clearTitle": "チャットをクリア",
    "clearConfirm": "この端末の全メッセージを削除しますか？元に戻せません。",
    "clear": "チャットクリア",
    "optionSelected": "選択済み: {{label}}",
    "sendingSelection": "送信中...",
    "connectionLost": "再接続中..."
  },
  "reminders": {
    "title": "マイリマインダー",
    "active": "アクティブ",
    "today": "今日",
    "thisWeek": "今週",
    "history": "履歴",
    "items": "件",
    "emptyTitle": "リマインダーはまだありません",
    "emptySubtitle": "チャットで作成するとここに表示されます。",
    "emptyAction": "チャットを開く",
    "filterActive": "アクティブ",
    "filterToday": "今日",
    "filterWeek": "今週",
    "filterHistory": "履歴",
    "emptyState": "リマインダーがありません。チャットを始めましょう！",
    "swipeDone": "完了",
    "swipeSnooze": "スヌーズ",
    "swipeDelete": "削除",
    "search": "リマインダーを検索...",
    "upcoming": "今後",
    "completed": "完了済み",
    "overdue": "期限切れ",
    "tomorrow": "明日",
    "synced": "同期済み {{value}}",
    "swipeHint": "リマインダーをスワイプして操作",
    "noResults": "検索に一致するリマインダーはありません",
    "noResultsHint": "別のキーワードを試すか検索をクリアしてください",
    "deleteAllFailed": "全リマインダーの削除に失敗しました"
  },
  "calendar": {
    "title": "カレンダー",
    "today": "今日",
    "tomorrow": "明日",
    "completed": "完了",
    "noEvents": "予定なし",
    "noEventsSubtitle": "日付を選択してリマインダーや予定を表示します。",
    "googleEvent": "Googleカレンダー",
    "legendActive": "アクティブ",
    "legendRecurring": "繰り返し",
    "legendDone": "完了",
    "legendGoogle": "Google",
    "previousMonth": "前月",
    "nextMonth": "次月",
    "previousYear": "前年",
    "nextYear": "翌年",
    "goToToday": "今日へ移動",
    "all": "すべて",
    "active": "アクティブ",
    "done": "完了",
    "paused": "一時停止"
  },
  "settings": {
    "title": "設定",
    "profile": "プロフィール",
    "name": "表示名",
    "enterName": "名前を入力",
    "language": "言語",
    "uiLanguage": "アプリ言語",
    "uiLanguageHelp": "この端末のアプリUI、カレンダーラベル、レイアウト方向を変更します。",
    "serverLanguage": "チャット言語",
    "serverLanguageHelp": "アカウントのサーバー返信とリマインダーの言語を変更します。",
    "timezone": "タイムゾーン",
    "currentTimezone": "現在のタイムゾーン",
    "timezoneHelp": "すべてのリマインダー時間はこのタイムゾーンで表示されます。",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "タイムゾーン保存",
    "timezoneSaved": "タイムゾーンを更新しました",
    "detect": "検出",
    "detectFailed": "タイムゾーンを検出できませんでした",
    "autoDetect": "GPSから自動検出",
    "notifications": "通知",
    "notificationsHelp": "フォローアップリマインダーはリマインダー後の繰り返し通知を制御します。端末の通知許可は電話設定で管理します。",
    "pushEnabled": "プッシュ通知",
    "autoDoneOnFire": "通知時に自動完了",
    "autoDoneOnFireDesc": "オフの場合、完了マークするまでアクティブのままです。",
    "googleCalendar": "Googleカレンダー",
    "google": "Googleカレンダー",
    "googleConnected": "接続済み",
    "googleDisconnected": "未接続",
    "googleConnectedHelp": "新しいリマインダーを自動でカレンダーに同期できます。",
    "googleDisconnectedHelp": "Googleカレンダーを接続してリマインダーと予定を同期しましょう。",
    "googleConnectFailed": "Googleカレンダーの接続に失敗しました",
    "connected": "接続済み",
    "disconnected": "未接続",
    "connect": "接続",
    "disconnect": "切断",
    "autoSync": "新しいリマインダーを自動同期",
    "autosync": "新しいリマインダーを自動同期",
    "subscription": "サブスクリプション",
    "trialUsed": "トライアル: {{used}}/{{total}} 使用済み",
    "trialStatus": "トライアル利用可能",
    "activeStatus": "サブスクリプション有効",
    "expiredStatus": "サブスクリプション期限切れ",
    "unsubscribedStatus": "未加入",
    "about": "情報",
    "version": "バージョン",
    "logout": "ログアウト",
    "logoutTitle": "ログアウト",
    "logoutConfirm": "ログアウトしてもよろしいですか？",
    "noName": "名前未設定",
    "serverConnection": "サーバー接続",
    "serverUrl": "サーバーURL",
    "serverEdit": "編集",
    "saveReconnect": "保存して再接続",
    "resetDefault": "デフォルトにリセット",
    "invalidServerUrlTitle": "無効なサーバーURL",
    "invalidServerUrlMessage": "有効なhttpまたはhttpsのサーバーURLを入力してください。例: https://example.com",
    "uiLanguageChangeFailed": "アプリ言語の変更に失敗しました。再試行してください。",
    "serverLanguageChangeFailed": "チャット言語の変更に失敗しました。再試行してください。",
    "timezoneChangeFailed": "タイムゾーンの変更に失敗しました。再試行してください。",
    "autoSyncChangeFailed": "自動同期の更新に失敗しました。再試行してください。",
    "nameChangeFailed": "表示名の更新に失敗しました。再試行してください。",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "リマインダー詳細",
    "editTime": "時間を編集",
    "rename": "名前変更",
    "snooze": "スヌーズ",
    "snooze15": "15分スヌーズ",
    "pause": "一時停止",
    "pauseReminder": "リマインダーを一時停止",
    "resume": "再開",
    "resumeReminder": "リマインダーを再開",
    "skip": "次をスキップ",
    "skipOccurrence": "この発生をスキップ",
    "syncGoogle": "Googleに同期",
    "delete": "削除",
    "deleteTitle": "リマインダー削除",
    "deleteConfirm": "このリマインダーは完全に削除されます。",
    "deleteRecurringTitle": "繰り返しリマインダー削除",
    "deleteRecurringMessage": "この発生をスキップしますか？それとも全シリーズを削除しますか？",
    "deleteThisOccurrence": "この発生をスキップ",
    "deleteEntireSeries": "全シリーズを削除",
    "done": "完了",
    "markDone": "完了にする",
    "undo": "復元",
    "undoPrompt": "再度アクティブにしますか？今すぐ復元してください。",
    "recurring": "繰り返し",
    "nextRun": "次の実行",
    "oneTime": "一度きり",
    "pending": "保留中",
    "sent": "送信済み",
    "paused": "一時停止中",
    "active": "アクティブ",
    "snoozed": "スヌーズ中",
    "localTime": "現地時間で表示",
    "recurrence": "繰り返し設定",
    "created": "作成日",
    "tags": "タグ",
    "fireCount": "通知回数",
    "actions": "操作",
    "none": "なし",
    "snoozeFailed": "スヌーズに失敗しました",
    "pauseFailed": "一時停止に失敗しました",
    "resumeFailed": "再開に失敗しました",
    "skipFailed": "スキップに失敗しました",
    "doneFailed": "完了マークに失敗しました",
    "undoFailed": "復元に失敗しました",
    "deleteFailed": "削除に失敗しました",
    "rescheduleTitle": "再スケジュールしますか？",
    "rescheduleMsg": "このリマインダーは期限切れです。再スケジュールしますか？",
    "reschedule15": "15分後に",
    "reschedule60": "1時間後に",
    "keepOverdue": "そのままにする"
  },
  "onboarding": {
    "slide1Title": "FishMemoryへようこそ",
    "slide1Sub": "あなたの個人リマインダーアシスタント — WhatsApp搭載、ポケットサイズ。",
    "slide2Title": "自然にチャットするだけ",
    "slide2Sub": "「明日午後3時に母に電話するようにリマインドして」など、思ったまま入力してください。あとはお任せ。",
    "slide3Title": "大事なことを見逃さない",
    "slide3Sub": "タイムリーな通知、タグで整理、重要なことをしっかり管理。",
    "getStarted": "始める",
    "next": "次へ",
    "firstReminderTitle": "最初のリマインダーを作成！",
    "firstReminderHint": "例えば、以下を入力してみてください：",
    "firstReminderExample": "明日9時に水を飲むようにリマインドして",
    "gotIt": "了解！",
    "notifRationaleTitle": "時間を守ろう",
    "notifRationaleBody": "FishMemoryは時間通りに通知するために通知が必要です。作成したリマインダーのみ通知されます。",
    "notifRationaleAllow": "通知を有効にする",
    "notifRationaleLater": "あとで",
    "swipeHint": "右にスワイプでクイック操作 →",
    "calendarDragHint": "ドラッグで拡大 ↕"
  }
}
